import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=7ae94498&scoped=true&"
import script from "./MessagesList.vue?vue&type=script&lang=ts&"
export * from "./MessagesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae94498",
  null
  
)

export default component.exports